import _objectSpread from "/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/@babel+runtime@7.29.2/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.function.name.js";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'switch_account_config',
  props: {
    disabled: Boolean,
    value: {
      type: Object,
      default: function _default() {
        return {};
      }
    }
  },
  data: function data() {
    return {
      rules: {
        name: [{
          required: true,
          message: '按钮名称不可为空',
          trigger: 'change'
        }, {
          min: 1,
          max: 5,
          message: '标题字数应大于等于1个字符小于5个字符!',
          trigger: 'change'
        }],
        account_sort: [{
          required: true,
          message: '请选择企业排列顺序',
          trigger: 'change'
        }]
      }
    };
  },
  created: function created() {
    var _this$value$config = this.value.config,
      _this$value$config$na = _this$value$config.name,
      name = _this$value$config$na === void 0 ? '切换企业' : _this$value$config$na,
      _this$value$config$ac = _this$value$config.account_sort,
      account_sort = _this$value$config$ac === void 0 ? 1 : _this$value$config$ac,
      _this$value$config$sw = _this$value$config.switch_font_size,
      switch_font_size = _this$value$config$sw === void 0 ? 30 : _this$value$config$sw,
      _this$value$config$sw2 = _this$value$config.switch_color,
      switch_color = _this$value$config$sw2 === void 0 ? '#333333' : _this$value$config$sw2,
      _this$value$config$bu = _this$value$config.button_font_size,
      button_font_size = _this$value$config$bu === void 0 ? 30 : _this$value$config$bu,
      _this$value$config$bu2 = _this$value$config.button_color,
      button_color = _this$value$config$bu2 === void 0 ? '#333333' : _this$value$config$bu2;
    this.$set(this.value, 'config', _objectSpread(_objectSpread({}, this.value.config), {}, {
      name: name,
      account_sort: account_sort,
      switch_font_size: switch_font_size,
      // 切换名称大小
      switch_color: switch_color,
      // 切换名称颜色
      button_font_size: button_font_size,
      // 按钮名称大小
      button_color: button_color // 按钮名称颜色
    }));
  }
};